<template>
  <screen
    can-skip
    :screen-name="screenName"
    :screen-info="info"
    :blank="scanCompleted"
    :show-intro.sync="showIntro"
    :intro-duration="introDuration"
    :error="error && state === 0"
    @skip="leave"
  >
    <doll
      :left="left"
      :right="right"
      :left-range="leftRange"
      :right-range="rightRange"
      :show-bubbles="!scanCompleted"
      :show-progress="scanProgress > -1 && !scanCompleted"
      :progress="scanProgress"
      left-breathing
      right-breathing
      @left-hit="handleLeftHit"
      @right-hit="handleRightHit"
    />
    <countdown v-if="countdownTimer > 0" :time="countdownTimer" />
    <scan-complete v-show="scanCompleted" :second-time="second" />
  </screen>
</template>

<script>
import incein from '@/mixins/incein';
import scanBody from '@/mixins/scan-body';
import audioPlayer from '@/mixins/audio-player';
import stampBgm from '@/mixins/stamp-bgm';
import { wait } from '@/modules/utils';
import i18n from '@/i18n';

import ScanComplete from '../../components/Stamp/ScanComplete.vue';
import Screen from '../../components/Stamp/Screen.vue';
import Doll from '../../components/Stamp/Doll.vue';
import Countdown from '../../components/Stamp/Countdown.vue';

export default {
  name: 'ScanBody',
  components: {
    Screen,
    Doll,
    ScanComplete,
    Countdown,
  },
  props: {
    second: Boolean,
  },
  mixins: [scanBody, audioPlayer, stampBgm, incein],
  mounted() {
    this.toggleArmMotionListening(false);
    if (this.second) {
      this.startArmDetection();
      this.playAudio('v13_13');
    } else {
      this.playAudio('v13_11');
    }
  },
  data: () => ({
    info: i18n.t('stamp.feet_position'),
    showFeet: false,
  }),
  methods: {
    finish() {
      this.$events.goto('Analyzing', { params: { second: this.second } });
    },
  },
  computed: {
    screenName() {
      if (this.second) return this.$t('stamp.scan_step_name_2');

      if (this.showIntro) {
        return this.isIncein
          ? this.$t('incein.scan_step_name_begin')
          : this.$t('stamp.scan_step_name_begin');
      }
      return this.$t('stamp.scan_step_name');
    },
    introDuration() {
      return this.second ? 3 : 6;
    },
  },
  watch: {
    countdownTimer(nv, ov) {
      if (nv >= 2) {
        this.playCountDown();
      }
      if (nv === 1) {
        this.playCountDownLast();
      }
      if (nv === 0 && ov === 1) {
        this.playScanning();
      }
    },
    showIntro(nv, ov) {
      if (!nv && ov) {
        this.toggleArmMotionListening(true);
        this.info = i18n.t('stamp.scan_body_start');
        this.playAudio('v13_12')
          .then(() => wait(1))
          .then(() => {
            if (!this.somethingHit) {
              this.showError();
            }
          });
      }
    },
    somethingHit(nv) {
      this.error = !nv;
    },
    error(nv) {
      if (nv && this.state === 0) {
        this.playNegative();
      }
    },
    state(nv) {
      if (nv === 1) {
        this.playAudio('Voice6', true);
        this.info = this.isIncein
          ? this.$t('incein.scan_in_progress')
          : this.$t('stamp.scan_in_progress');
      }
    },
    async bothReady(nv) {
      if (nv && this.state === 0) {
        this.error = false;
        try {
          await this.startScan();
        } catch (e) {
          console.log(`[ERROR] scan failed! ${e.message}`);
          this.leave(this.$t('welcome.unexpected_error'));
        }
      }
    },
    scanCompleted(nv, ov) {
      if (nv && !ov) {
        this.playPositive();
        this.playAudio(this.second ? '37' : '29', true).then(() => {
          this.finish();
        });
      }
    },
  },
};
</script>
